export default __webpack_public_path__ + "static/and-logo-3-25b6b6beead2d980c6027dc0a70b6a40.webp";